import React from 'react';

export default class SizePosition extends React.Component {
    element = null;

    setElement(newElement) {
        this.element = newElement;
    }

    getBoundingClientRect() {
        if (this.element) {
            return this.element.getBoundingClientRect();
        }
        return null;
    }
}
